import React, {
  useEffect, useState, useRef, useContext,
} from 'react';
import Button from '../@base/Button';
import Avatar from '../@base/Avatar';
import FotoAvatar from '../../assets/avatar.png';
import UserContext from '../../context/UserContext';

/** Painel da exibição do avatar do usuário,
 *  constando informações do usuario e botão de logout */
export function AvatarPanel() {
  const userContext = useContext(UserContext);

  const infoAccount = useRef();
  const [showInfoAccount, setShowInfoAccount] = useState(null);

  const clickOutHandler = (e) => {
    if (infoAccount.current.contains(e.target)) {
      return;
    }
    setShowInfoAccount(false);
  };

  const logoutButtonHandler = () => {
    localStorage.removeItem('provider');
    userContext.oidcUser.signOut();
  };

  useEffect(() => {
    const reactFlowContainer = document.querySelector('.react-flow__pane');
    if (showInfoAccount) {
      if (reactFlowContainer) reactFlowContainer.addEventListener('mousedown', clickOutHandler);
      document.addEventListener('mousedown', clickOutHandler);
    }

    return () => {
      if (reactFlowContainer) reactFlowContainer.removeEventListener('mousedown', clickOutHandler);
      document.removeEventListener('mousedown', clickOutHandler);
    };
  }, [showInfoAccount]);

  return (
    <div className="avatar">
      <div className="content">
        <div role="button" onMouseEnter={() => setShowInfoAccount(true)} tabIndex={0}>
          <Avatar
            image={userContext.user.photo ? `data:image/jpeg;base64,${userContext.user.photo}` : FotoAvatar}
            alt="avatar"
          />
        </div>
        {showInfoAccount ? (
          <div className="account-info" ref={infoAccount}>
            <div className="user">
              {userContext.user.name}
            </div>
            <Button small onClick={logoutButtonHandler}>
              <small>Sair</small>
            </Button>
          </div>
        ) : null}
      </div>
    </div>
  );
}

export default AvatarPanel;
